<ngb-alert [hidden]="!child && !value" [type]="type" (close)="closeClick()" [dismissible]="dismissible"
           ngClass="{{classes}}">
      <i ngClass="icon icon-{{type}} mr-3 align-self-center"></i>
    <div [innerHTML]="value" [hidden]="!value" class="d-inline m-0"></div>
  <ng-content *ngIf="!value"></ng-content>
</ngb-alert>
